const ICONS = {
    menu: <><path d="M4 7h16M4 12h16M4 17h16" /></>,
    close: <><path d="M6 6l12 12M18 6L6 18" /></>,
    chevronDown: <path d="M6 9l6 6 6-6" />,
    chevronRight: <path d="M9 6l6 6-6 6" />,
    globe: (
        <>
            <circle cx="12" cy="12" r="9" />
            <path d="M3 12h18M12 3c3 3.5 3 14.5 0 18M12 3c-3 3.5-3 14.5 0 18" />
        </>
    ),
    suitcase: (
        <>
            <rect x="4" y="8" width="16" height="12" rx="2" />
            <path d="M9 8V6a2 2 0 012-2h2a2 2 0 012 2v2" />
            <path d="M4 13h16" />
        </>
    ),
    synagogue: (
        <>
            <path d="M4 21h16" />
            <path d="M6 21V11l6-5 6 5v10" />
            <path d="M10 21v-5h4v5" />
            <path d="M10 9l2-2 2 2" />
        </>
    ),
    candles: (
        <>
            <path d="M9 21V10M15 21V8" />
            <path d="M6 21h12" />
            <path d="M9 8c0-1 1-1 0-3M15 6c0-1 1-1 0-3" />
        </>
    ),
    heart: <path d="M12 20.5l-1.5-1.3C6 15.4 3 12.8 3 9.5 3 7 5 5 7.5 5c1.5 0 2.9.7 3.8 1.8h1.4C13.6 5.7 15 5 16.5 5 19 5 21 7 21 9.5c0 3.3-3 5.9-7.5 9.7L12 20.5z" />,
    question: (
        <>
            <circle cx="12" cy="12" r="9" />
            <path d="M9.5 9.5a2.5 2.5 0 015 0c0 1.5-2.5 2-2.5 3.5M12 17v.01" />
        </>
    ),
    whatsapp: (
        <>
            <path d="M20.5 12a8.5 8.5 0 01-12.7 7.4L3 21l1.6-4.8A8.5 8.5 0 1120.5 12z" />
            <path d="M8.5 10c.3 2 2 3.7 4 4 .6 0 1.3-.3 1.5-.9l-1.3-.8c-.3.2-.6.4-.9.2-.7-.3-1.4-1-1.7-1.7-.1-.3 0-.6.2-.9l-.8-1.3c-.6.3-.9.9-.9 1.5-.1.3-.1.6-.1.9z" />
        </>
    ),
    instagram: (
        <>
            <rect x="3" y="3" width="18" height="18" rx="5" />
            <circle cx="12" cy="12" r="4" />
            <circle cx="17.5" cy="6.5" r=".9" fill="currentColor" />
        </>
    ),
    facebook: <path d="M14 21v-7h2.5l.5-3H14V9c0-.9.3-1.5 1.6-1.5H17V5c-.3 0-1.3-.1-2.3-.1-2.3 0-3.7 1.4-3.7 3.9V11H9v3h2v7h3z" />,
    mail: (
        <>
            <rect x="3" y="5" width="18" height="14" rx="2" />
            <path d="M3 7l9 7 9-7" />
        </>
    ),
    phone: <path d="M5 4h3l2 5-2.5 1.5a11 11 0 006 6L15 14l5 2v3a2 2 0 01-2 2A15 15 0 013 6a2 2 0 012-2z" />,
    mapPin: (
        <>
            <path d="M12 21c-4-4.5-7-8-7-11a7 7 0 0114 0c0 3-3 6.5-7 11z" />
            <circle cx="12" cy="10" r="2.5" />
        </>
    ),
    arrowRight: (
        <>
            <path d="M5 12h14" />
            <path d="M13 6l6 6-6 6" />
        </>
    ),
    stars: (
        <>
            <path d="M12 3l1.6 3.6L17 8l-3.4 1.4L12 13l-1.6-3.6L7 8l3.4-1.4z" />
            <path d="M18 14l.8 1.8L21 17l-2.2.8L18 20l-.8-1.8L15 17l2.2-1z" />
        </>
    ),
    book: (
        <>
            <path d="M5 4h11a2 2 0 012 2v14H7a2 2 0 01-2-2z" />
            <path d="M5 18a2 2 0 012-2h11" />
            <path d="M9 8h6M9 11h6" />
        </>
    ),
    meal: (
        <>
            <path d="M7 3v8M5 3v4a2 2 0 004 0V3" />
            <path d="M7 11v10" />
            <path d="M16 3c-1.5 0-2.5 2-2.5 5s1 4 2.5 4 2.5-1 2.5-4-1-5-2.5-5z" />
            <path d="M16 16v5" />
        </>
    ),
};

export default function Icon({ name, size = 24, stroke = 1.75, className = "", fill = "none", ...rest }) {
    const body = ICONS[name];
    if (!body) return null;
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill={fill}
            stroke="currentColor"
            strokeWidth={stroke}
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
            className={className}
            {...rest}
        >
            {body}
        </svg>
    );
}
